import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { PanelType } from 'office-ui-fabric-react/lib/Panel';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import React, { Component } from 'react';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Scriba from 'react-scriba';
import ImmocomContext from '../../contexts/ImmocomContext.js';
import { DataTicket } from '../../data/DataTicket.jsx';
import { MaxLengths } from '../../data/MaxLenghts.jsx';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxAgence } from '../ComboBox/ComboBoxAgence.jsx';
import { ComboBoxBacklogAzure } from '../ComboBox/ComboBoxBacklogAzure';
import { ComboBoxDepartementAdministratif } from '../ComboBox/ComboBoxDepartementAdministratif.jsx';
import { ComboBoxDomaine } from '../ComboBox/ComboBoxDomaine';
import { ComboBoxEtat } from '../ComboBox/ComboBoxEtat';
import { ComboBoxFonctionnalite } from '../ComboBox/ComboBoxFonctionnalite';
import { ComboBoxIterationAzure } from '../ComboBox/ComboBoxIterationAzure';
import { ComboBoxOperation } from '../ComboBox/ComboBoxOperation.jsx';
import { ComboBoxPriorite } from '../ComboBox/ComboBoxPriorite';
import { ComboBoxRegion } from '../ComboBox/ComboBoxRegion.jsx';
import { ComboBoxRegionAdministrative } from '../ComboBox/ComboBoxRegionAdministrative.jsx';
import { ComboBoxSalariesScribaNet } from '../ComboBox/ComboBoxSalariesScribaNet';
import { ComboBoxVilleAdministrative } from '../ComboBox/ComboBoxVilleAdministrative.jsx';
import { EUIDatePicker } from '../EUI/EUIDatePicker.jsx';
import { EUIDialog } from '../EUI/EUIDialog.jsx';
import { EUIPanel } from '../EUI/EUIPanel.jsx';
import { EUIRichTextField } from '../EUI/EUIRichTextField.jsx';
import { EUISeparator } from '../EUI/EUISeparator.jsx';
import { EUITextField } from '../EUI/EUITextField.jsx';
import { DetailsListEvenementHub } from '../List/DetailsListEvenementHub';
import { DetailsListHistorique } from '../List/DetailsListHistorique';
import { PickerCompte } from '../Picker/PickerCompte';
import { TextFieldTemps } from '../TextField/TextFieldTemps.jsx';
import './FicheTicket.css';

// KP - 26/06/2023 : composant raccordé à ImmocomContext pour tests
export class FicheTicket extends Component {

    static contextType = ImmocomContext;

    static defaultProps = {
        idTache: undefined,
        idTicket: undefined,
        isOpen: false,
        /* --- */
        onDismiss: () => null,
        onSave: () => null
    };

    static defaultState = {
        srcFileData: "",
        stringFileData: "",
        ticket: {
            description: "",
            descriptionTechnique: "",
            idAgence: 0,
            idDepartementAdministratif: '0',
            idOperation: 0,
            idRegion: 0,
            idRegionAdministrative: 0,
            idVilleAdministrative: '0',
            ouvert: true,
            perimetreNational: true,
        },
        /* --- */
        affichagePerimetreAdministratif: false,
        affichagePerimetreEiffage: false,
        affichagePerimetreNational: true,
        afficherDialogSuppressionImpressionEcran: false,
        afficherDialogImpressionEcran: false,
        estOngletTicketActif: true,
        estOngletHistoriqueActif: false,
        estOngletEvenementHubActif: false,
        onActiveBoutonEnregistrer: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheTicket.defaultState };
    };

    _chargementDonnees = () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const messageId = addMessage("loading", "Chargement du ticket en cours...");

        const { idTicket } = this.props;

        DataTicket._chargementFicheTicket(idTicket).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {

                const objetData = responseFetch.reponseAPIobjet;
                const ticket = objetData[0];
                const itemFileData = objetData[1];

                const affichagePerimetreNational = !!ticket.perimetreNational;
                const affichagePerimetreEiffage = !!ticket.idRegion;
                const affichagePerimetreAdministratif = !!ticket.idRegionAdministrative;

                let state = {
                    affichagePerimetreAdministratif,
                    affichagePerimetreEiffage,
                    affichagePerimetreNational,
                    srcFileData: "",
                    stringFileData: itemFileData,
                };

                if (!!ticket) {
                    if (ticket.tempsPrevu && ticket.tempsPrevu < 3600) { // less than an hour
                        ticket.tempsPrevu = Math.round(ticket.tempsPrevu / 60);
                        ticket.tempsType = 'Minute';
                    }
                    else if (ticket.tempsPrevu && ticket.tempsPrevu >= 3600 && ticket.tempsPrevu < 86400) { // more than an hour and less than a day
                        ticket.tempsPrevu = Math.round(ticket.tempsPrevu / 3600);
                        ticket.tempsType = 'Heure';
                    }
                    else if (ticket.tempsPrevu) { // more than a day
                        ticket.tempsPrevu = Math.round(ticket.tempsPrevu / 86400);
                        ticket.tempsType = 'Jour';
                    }

                    /* YD : 20221114 : EvoTicketHub */
                    if (ticket.tempsPasse && ticket.tempsPasse < 60) { // less than an hour
                        //itemTicket.tempsPrevu = Math.round(itemTicket.tempsPrevu / 60);
                        ticket.tempsPasseType = 'Minute';
                    }
                    else if (ticket.tempsPasse && ticket.tempsPasse >= 60 && ticket.tempsPasse <= (7 * 60)) { // more than an hour and less than a day
                        ticket.tempsPasseFormate = Math.round(ticket.tempsPasse / 60);
                        ticket.tempsPasseType = 'Heure';
                    }
                    else if (ticket.tempsPasse) { // more than a day
                        ticket.tempsPasseFormate = Math.round(ticket.tempsPasse / (7 * 60));
                        ticket.tempsPasseType = 'Jour';
                    }
                }
                state.ticket = ticket;

                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._onVerificationFormulaire);
            }
            else fetchMessages(responseFetch);
            dismissMessage(messageId);
        });

    };

    _getItems = () => {
        return [
            {
                key: "coller",
                name: "Coller",
                iconProps: { iconName: "Paste" },
                onClick: this._toggleDialog("ImpressionEcran", true)
            },
            {
                key: "supprimer",
                name: "Supprimer",
                iconProps: { iconName: "Delete" },
                onClick: this._toggleDialog("SuppressionImpressionEcran", true)
            }
        ];
    };

    _onChangeChoiceGroupPerimetreEiffage = (ev, option) => {
        Immocom.perimetre()._onChangeChoiceGroupPerimetreEiffage(this, 'ticket', ev, option, this._onVerificationFormulaire);
    };

    _onChangePerimetre = (key, value) => {
        let ticket = { ...this.state.ticket, [key]: value };

        switch (key) {
            case "idRegion": ticket.idAgence = 0;
            case "idAgence": ticket.idOperation = 0; break;

            case "idRegionAdministrative": ticket.idDepartementAdministratif = "0";
            case "idDepartementAdministratif": ticket.idVilleAdministrative = "0";
            case "idVilleAdministrative": ticket.idOperation = 0; break;

            default: break;
        }

        this.setState({ ticket }, this._onVerificationFormulaire);
    };

    _onEnregistrement = () => {

        const { addMessage, dismissMessage, fetchMessages } = this.context;
        const loadingMessageId = addMessage("loading", "Enregistrement du ticket en cours...");

        const { idTicket, onSave } = this.props;
        const { ticket } = this.state;
        const idTache = this.props.idTache || this.state.ticket.idTache;

        DataTicket._onEnregistrementTicket(idTicket, idTache, ticket, this.state.stringFileData)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null)
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, onSave);
                else fetchMessages(responseFetch);
                dismissMessage(loadingMessageId);
            });

    };

    _onMiseAJourChamp = (nomObjet, nomPropriete, valeur) => {
        Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, valeur, this._onVerificationFormulaire);

        if (this.props.onAffichageSansPanel) {
            this.props.onChange(nomPropriete, valeur);
        }
    };

    _onOpen = () => {
        const { idTicket } = this.props;
        this.setState({ ...FicheTicket.defaultState });
        if (!!idTicket)
            this._chargementDonnees();
    };

    _onVerificationFormulaire = () => {
        const { ticket } = this.state;
        Immocom.fiche()._validationFormulaire(this, "Ticket", ticket, this.props.idTicket > 0 ? "Modification" : "Création");
    };

    _screenshot_getImage = (pasteEvent, callback) => {
        if (pasteEvent.clipboardData === false && typeof (callback) === "function")
            callback(undefined);

        var items = pasteEvent.clipboardData.items;
        if (items === undefined && typeof (callback) === "function")
            callback(undefined);

        for (var i = 0; i < items.length; i++) {
            if (items[i].type.indexOf("image") === -1) continue; // Skip content if not image
            var blob = items[i].getAsFile(); // Retrieve image on clipboard as blob

            if (typeof (callback) === "function")
                callback(blob);
        }
    };

    _screenshot_paste = (event) => {
        this._screenshot_getImage(
            event,
            (image) => {
                // If there's an image, display it in the canvas
                if (!!image) {
                    var canvas = document.getElementById("mycanvasTicket");
                    var ctx = canvas.getContext('2d');

                    // Create an image to render the blob on the canvas
                    var img = new Image();

                    // Once the image loads, render the img on the canvas
                    img.onload = () => {
                        // Update dimensions of the canvas with the dimensions of the image
                        canvas.width = this.width;
                        canvas.height = this.height;

                        // Draw the image
                        ctx.drawImage(img, 0, 0);
                    };

                    // Crossbrowser support for URL
                    var URLObj = window.URL || window.webkitURL;

                    // Creates a DOMString containing a URL representing the object given in the parameter
                    // namely the original Blob
                    img.src = URLObj.createObjectURL(image);

                    var fileReader = new FileReader();
                    fileReader.readAsDataURL(image);
                    fileReader.onload = (event) => {
                        let srcB64 = fileReader.result;
                        this.setState({
                            srcFileData: img.src,
                            stringFileData: srcB64
                        });
                    };
                }
            }
        );
    };

    _screenshot_reset = () => {
        this.setState({
            srcFileData: "",
            stringFileData: ""
        });
    };

    _toggleDialog = (nomDialog, isOpen, item, callback) => () => {
        this.setState(
            {
                [`afficherDialog${nomDialog}`]: isOpen,
                itemActif: item,
            },
            !!callback && typeof callback === "function" ? callback() : null
        );
    };

    _toggleOnglet = (nomOnglet) => () => {
        this.setState({
            estOngletEvenementHubActif: false,
            estOngletHistoriqueActif: false,
            estOngletTicketActif: false,
            [`estOnglet${nomOnglet}Actif`]: true,
        });
    };

    componentDidMount = () => {
        window.addEventListener("paste", (e) => this._screenshot_paste(e), false);
    };

    componentWillUnmount = () => {
        document.removeEventListener("paste", (e) => this._screenshot_paste(e), false);
    };

    render = () => {

        const { idTicket, isOpen, onDismiss } = this.props;
        const {
            affichagePerimetreAdministratif, affichagePerimetreEiffage,
            afficherDialogImpressionEcran, afficherDialogSuppressionImpressionEcran,
            estOngletEvenementHubActif, estOngletHistoriqueActif, estOngletTicketActif,
            onActiveBoutonEnregistrer, srcFileData, stringFileData, ticket
        } = this.state;

        const screenshot = srcFileData || stringFileData;
        const perimetre = affichagePerimetreEiffage
            ? "eiffage"
            : affichagePerimetreAdministratif
                ? "administratif"
                : "national"
            ;

        return <EUIPanel
            headerText={!!idTicket ? `Modification du ticket ${idTicket}` : "Nouveau ticket"}
            isFormValid={onActiveBoutonEnregistrer}
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onSave={estOngletTicketActif ? this._onEnregistrement : undefined}
            type={PanelType.extraLarge}
        >
            <nav className="navbar navbar-expand-lg navbar-light border-bottom">
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavFicheContact" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNavFicheContact">
                    <ul className="navbar-nav">
                        <li className={`nav-item itemNavigationContact ${(estOngletTicketActif ? 'active' : '')}`} onClick={this._toggleOnglet("Ticket")}>TICKET</li>
                        {!!idTicket && <li className={`nav-item itemNavigationContact ${(estOngletHistoriqueActif ? 'active' : '')}`} onClick={this._toggleOnglet("Historique")}>HISTORIQUE</li>}
                        {!!idTicket && <li className={`nav-item itemNavigationContact ${(estOngletEvenementHubActif ? 'active' : '')}`} onClick={this._toggleOnglet("EvenementHub")}>EVENEMENT</li>}
                    </ul>
                </div>
            </nav>

            {estOngletTicketActif &&
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-lg1">
                            <EUITextField
                                disabled
                                label="Id"
                                value={ticket.idTicket}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg2">
                            <EUITextField
                                disabled
                                label="Envoi mail"
                                value={Scriba.date().stringDateFormatCourt(ticket.dateEnvoiMail)}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg7">
                            <PickerCompte
                                loginCompte={ticket.loginCompte}
                                idSociete={1}
                                onChange={(e) => Scriba.state().setObjetPropriete(this, "ticket", "loginCompte", e, this._onVerificationFormulaire)}
                                label="Comptes"
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg2">
                            <Toggle
                                label="Etat"
                                onText="Ouvert"
                                offText="Fermé"
                                onChange={(e, isChecked) => Scriba.state().setObjetPropriete(this, "ticket", "ouvert", isChecked, this._onVerificationFormulaire)}
                                checked={ticket.ouvert}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-lg3">
                            <ComboBoxDomaine
                                onChange={(event, option, index, value, item) => Scriba.state().setObjetProprietes(this, "ticket", [["idDomaine", option.key], ["idFonctionnalite", 0]], this._onVerificationFormulaire)}
                                selectedKey={ticket.idDomaine}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg3">
                            <ComboBoxFonctionnalite
                                idDomaine={ticket.idDomaine}
                                onChange={(event, option, index, value, item) => Scriba.state().setObjetPropriete(this, "ticket", "idFonctionnalite", option.key, this._onVerificationFormulaire)}
                                selectedKey={ticket.idFonctionnalite}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg2">
                            <ComboBoxEtat
                                onChange={(event, option, index, value, item) => Scriba.state().setObjetPropriete(this, "ticket", "idEtat", option.key, this._onVerificationFormulaire)}
                                selectedKey={ticket.idEtat}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg2">
                            <ComboBoxPriorite
                                onChange={(event, option, index, value, item) => Scriba.state().setObjetPropriete(this, "ticket", "priorite", option.key, this._onVerificationFormulaire)}
                                selectedKey={ticket.priorite}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg2">
                            <ComboBoxSalariesScribaNet
                                onChange={(event, option, index, value, item) => Scriba.state().setObjetPropriete(this, "ticket", "assigneA", option.key !== "0" ? option.key : null, this._onVerificationFormulaire)}
                                selectedKey={ticket.assigneA}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-lg8">
                            <ChoiceGroup
                                label="Périmètre"
                                options={[
                                    {
                                        key: 'national',
                                        iconProps: { iconName: 'World' },
                                        text: 'National'
                                    },
                                    {
                                        key: 'eiffage',
                                        iconProps: { iconName: 'GlobeFavorite' },
                                        text: 'Eiffage'
                                    },
                                    {
                                        key: 'administratif',
                                        iconProps: { iconName: 'HomeSolid' },
                                        text: 'Administratif'
                                    }
                                ]}
                                onChange={this._onChangeChoiceGroupPerimetreEiffage}
                                selectedKey={perimetre}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg2">
                            <TextFieldTemps
                                disabled
                                label="Temps passé (min.)"
                                value={ticket.tempsPasse}
                                suffix="Minute"
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg2">
                            <TextFieldTemps
                                disabled
                                label="Temps passé"
                                value={ticket.tempsPasseFormate}
                                suffix={ticket.tempsPasseType}
                            />
                        </div>
                    </div>

                    {perimetre === "eiffage" &&
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-md6 ms-xl3">
                                <ComboBoxRegion
                                    disabled={ticket.nationalAdministratif}
                                    onChange={(event, option, index, value, item) => this._onChangePerimetre("idRegion", option.key)}
                                    selectedKey={ticket.idRegion}
                                />
                            </div>

                            <div className="ms-Grid-col ms-sm12 ms-md6 ms-xl3">
                                <ComboBoxAgence
                                    idRegion={ticket.idRegion}
                                    onChange={(event, option, index, value, item) => this._onChangePerimetre("idAgence", option.key)}
                                    selectedKey={ticket.idAgence}
                                />
                            </div>

                            <div className="ms-Grid-col ms-sm12 ms-xl6">
                                <ComboBoxOperation
                                    idRegion={ticket.idRegion}
                                    idAgence={ticket.idAgence}
                                    onChange={(event, option, index, value, item) => this._onChangePerimetre("idOperation", option.key)}
                                    perimetre="eiffage"
                                    selectedKey={ticket.idOperation}
                                />
                            </div>
                        </div>
                    }

                    {perimetre === "administratif" &&
                        <div className="ms-Grid-row">
                            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl3">
                                <ComboBoxRegionAdministrative
                                    disabled={ticket.nationalAdministratif}
                                    onChange={(event, option, index, value, item) => this._onChangePerimetre("idRegionAdministrative", option.key)}
                                    selectedKey={ticket.idRegionAdministrative}
                                />
                            </div>

                            <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl3">
                                <ComboBoxDepartementAdministratif
                                    disabled={!ticket.idRegionAdministrative}
                                    idRegionAdministrative={ticket.idRegionAdministrative}
                                    onChange={(event, option, index, value, item) => this._onChangePerimetre("idDepartementAdministratif", option.key)}
                                    selectedKey={ticket.idDepartementAdministratif}
                                />
                            </div>

                            <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl3">
                                <ComboBoxVilleAdministrative
                                    disabled={!ticket.idDepartementAdministratif || ticket.idDepartementAdministratif === "0"}
                                    idDepartementAdministratif={ticket.idDepartementAdministratif}
                                    idRegionAdministrative={ticket.idRegionAdministrative}
                                    onChange={(event, option, index, value, item) => this._onChangePerimetre("idVilleAdministrative", option.key)}
                                    selectedKey={ticket.idVilleAdministrative}
                                />
                            </div>

                            <div className="ms-Grid-col ms-sm12 ms-xl3">
                                <ComboBoxOperation
                                    disabled={!ticket.idVilleAdministrative || ticket.idVilleAdministrative === "0"}
                                    idDepartementAdministratif={ticket.idDepartementAdministratif}
                                    idRegionAdministrative={ticket.idRegionAdministrative}
                                    idVilleAdministrative={ticket.idVilleAdministrative}
                                    onChange={(event, option, index, value, item) => this._onChangePerimetre("idOperation", option.key)}
                                    perimetre="administratif"
                                    selectedKey={ticket.idOperation}
                                />
                            </div>
                        </div>
                    }

                    <EUISeparator iconName="AzureAPIManagement" text="DevOps" />

                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-lg2">
                            <ComboBoxIterationAzure
                                onChange={(event, option) => Scriba.state().setObjetProprietes(this, "ticket", [["iterationName", option.key], ["idBacklog", 0]], this._onVerificationFormulaire)}
                                selectedKey={ticket.iterationName}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg2">
                            <ComboBoxBacklogAzure
                                iterationName={ticket.iterationName}
                                onChange={(event, option) => Scriba.state().setObjetPropriete(this, "ticket", "idBacklog", option.key, this._onVerificationFormulaire)}
                                selectedKey={ticket.idBacklog}
                            />
                        </div>

                        <div className="ms-Grid-col ms-sm12 ms-lg2">
                            <EUIDatePicker
                                allowTextInput={false}
                                label="Date de réalisation"
                                onSelectDate={date => this._onMiseAJourChamp("ticket", "dateDeRealisation", Scriba.date().getChaineISOFromDate(date))}
                                value={ticket.dateDeRealisation}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-lg2">
                            <TextFieldTemps
                                label="Temps prévu"
                                onChange={(event, newValue, suffix) => Scriba.state().setObjetProprietes(this, "ticket", [["tempsPrevu", newValue], ["tempsType", suffix]])}
                                suffix={ticket.tempsType}
                                value={ticket.tempsPrevu}
                            />
                        </div>
                    </div>

                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 mt-2">
                            <EUIRichTextField
                                label="Description du ticket"
                                maxLength={MaxLengths.ticket.description}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "ticket", "description", newValue, this._onVerificationFormulaire)}
                                required
                                value={ticket.description}
                            />
                        </div>
                    </div>
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12">
                            <EUIRichTextField
                                label="Description technique"
                                maxLength={MaxLengths.ticket.descriptionTechnique}
                                onChange={() => this.setState({ onActiveBoutonEnregistrer: false })}
                                onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "ticket", "descriptionTechnique", newValue, this._onVerificationFormulaire)}
                                required
                                value={ticket.descriptionTechnique}
                            />
                        </div>
                    </div>

                    <div className="ms-Grid-row impressionEcran">
                        <label className="ms-font-xxl ms-sm12">Impression d'écran</label>
                        <CommandBar
                            items={this._getItems()}
                            overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                            ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
                        />
                        {!!screenshot && <img
                            alt="Screenshot"
                            src={screenshot}
                            className="imgImpressionEcran ms-sm12"
                        />}
                        <canvas id="mycanvasTicket" className="ms-sm12"></canvas>
                    </div>

                </div>
            }

            {estOngletHistoriqueActif && <DetailsListHistorique idTicket={this.props.idTicket} />}

            {estOngletEvenementHubActif && <DetailsListEvenementHub idTicket={this.props.idTicket} />}

            <EUIDialog
                buttons={[
                    <PrimaryButton key="delete" onClick={this._toggleDialog("SuppressionImpressionEcran", false, {}, this._screenshot_reset)} text="Supprimer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialog("SuppressionImpressionEcran", false)} text="Annuler" />
                ]}
                isOpen={afficherDialogSuppressionImpressionEcran}
                onDismiss={this._toggleDialog("SuppressionImpressionEcran", false)}
                titre="Suppression de l'impression d'écran"
            >
                Etes-vous certain de vouloir supprimer cette impression d'écran ?
            </EUIDialog>

            <EUIDialog
                buttons={[<DefaultButton key="ok" onClick={this._toggleDialog("ImpressionEcran", false)} text="OK" />]}
                isOpen={afficherDialogImpressionEcran}
                onDismiss={this._toggleDialog("ImpressionEcran", false)}
                titre="Fonctionnalité non disponible"
            >
                Veuillez utiliser la combinaison "Ctrl + V" pour copier votre image.
            </EUIDialog>

        </EUIPanel>;
    };

};